import { SxProps } from '@mui/material/styles';

const root: SxProps = {
  minHeight: '100vh',
  position: 'absolute',
  display: 'flex',
  zIndex: 0,
  width: '100%',
};

const container: SxProps = {
  flex: 1,
  top: 0,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  px: { xs: 2, md: 6 },
};

const contentContainer: SxProps = {
  ...container,
  flexDirection: 'column',
  maxWidth: 900,
  py: { xs: 4, md: 8 },
};

const title: SxProps = {
  fontWeight: 700,
  mt: 4,
};

const subtitle: SxProps = {
  mt: 4,
  fontWeight: 600,
};

const paragraph: SxProps = {
  mt: 2,
};

const logoImage = {
  width: 96,
  height: 140,
};

export {
  root,
  container,
  contentContainer,
  title,
  subtitle,
  paragraph,
  logoImage,
};
